<template>
  <div>
    <div class="accountbg"></div>
    <div class="wrapper-page">
      <div class="card">
        <div class="card-block">
          <div class="ex-page-content text-center">
            <h1 class>404!</h1>
            <h4 class>Sorry, page not found</h4>
            <br />
          </div>
        </div>
      </div>
    </div>
    <!-- {{authData()}} -->
  </div>
</template>

<script>
// import { authData } from '@/util/auth_code'

export default {
  data() {
    return {
      // authData,
    }
  },
}
</script>